import { useState } from 'react';
import { Icon } from '@material-ui/core';
import './DataTable.scss';
import Pagination from 'react-responsive-pagination';
import { Table } from 'react-bootstrap';

const DataTable = ({ tableInputFrom, tableHeading, iconHeading, tableBodyData }) => {
    // Pagination State
    const [currentPage, setCurrentPage] = useState(1);
    const totalPages = 5;


    return (
        <div className="DataTable bg-white px-3 rounded " id="dataTable">
            <div className="input-group row mx-0 py-3 justify-content-end">
                {tableInputFrom}
            </div>
            <Table responsive className="table table-striped">
                <thead className="MAIN_BG_DARK_GREEN text-white">
                    <tr className="text-center">
                        {
                            tableHeading && tableHeading.map((heading, index) =>
                                <th key={index} scope="col" className="py-2 userID">
                                    <b>{heading}</b>{!iconHeading && <i className="fa fa-fw fa-sort"></i>}
                                </th>
                            )}
                    </tr>
                </thead>
                <tbody>
                    {tableBodyData}
                </tbody>
            </Table>
            <div className="py-4 pagination d-flex justify-content-end align-items-center">
                <div style={{ padding: '5px 6px', backgroundColor: '#FFFFFF', border: '1px solid #DEE2E6', borderRadius: '2px' }} className={`skipBtn ${currentPage <= 1 ? "opacity-50" : "opacity-100"}`}>
                    <Icon onClick={() => currentPage > 0 ? setCurrentPage(1) : setCurrentPage(currentPage - 4)}>skip_previous</Icon>
                </div>
                <Pagination
                    current={currentPage}
                    total={totalPages}
                    onPageChange={setCurrentPage}
                />
                <div style={{ padding: '5px 6px', backgroundColor: '#FFFFFF', border: '1px solid #DEE2E6', borderRadius: '2px' }} className={`${currentPage <= 1 ? "opacity-25" : "opacity-100"}`}>
                    <Icon onClick={() => totalPages === currentPage ? setCurrentPage(totalPages) : setCurrentPage + 4}>skip_next</Icon>
                </div>
            </div >
        </div >
    );
}

export default DataTable;